import * as styles from './video.styles'

export function PlayButton() {
  return (
    <>
      <div css={styles.playBorder} />
      <div css={styles.play}>
        <svg
          fill="none"
          height="20"
          viewBox="0 0 17 20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.78 8.72 2.281.47A1.5 1.5 0 0 0 0 1.751v16.498a1.501 1.501 0 0 0 2.282 1.28L15.78 11.28a1.5 1.5 0 0 0 0-2.56"
            fill="#450D87"
          />
        </svg>
      </div>
    </>
  )
}
